module.exports = __webpack_public_path__ + "img/client-alsharq.3d1db794.jpeg";